import React from 'react';
import styled from 'styled-components';
import COLORS from '../../../constants/COLORS';

const Message = styled.div`
  display: block;
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 12px;
  padding: 2px 8px;
  white-space: nowrap;
  background: ${COLORS.BLACK};
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    left: 15px;
    top: -4px;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;

    border-bottom: 4px solid ${COLORS.BLACK};
  }
`;

const Tooltip = ({ message, style }) => {
  return <Message style={style}>{message}</Message>;
};

export default Tooltip;
